import { useState, ReactNode } from "react";
import { MRT_PaginationState, MRT_SortingState } from "material-react-table";

import {
    useAllIngredientReferences,
    IngredientReference,
} from "src/api/client-api/ingredientReference/useAllIngredientReferences";
import { useDelayedSearch } from "src/utils/useDelayedSearch";
import { useGridColumns } from "src/components/Grid/hooks/columnsExtension/useGridColumns.tsx";

import { useIngredientReferenceColumns } from "./useIngredientReferenceColumns";
import {
    IngredientReferenceListContext,
    IngredientReferenceListContextInitialValues,
} from "./useIngredientReferenceListContext";

type ProviderProps = {
    children: ReactNode;
};

export const IngredientReferenceListContextProvider = (props: ProviderProps) => {
    const { children } = props;

    const gridKey = "settings-ingredient-references-grid";

    const [page, setPage] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [sorting, setSorting] = useState<MRT_SortingState>([{ id: "name", desc: false }]);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const search = useDelayedSearch();
    const { ingredientReferences, isLoading, totalItems } = useAllIngredientReferences({
        page: page.pageIndex + 1,
        itemsPerPage: page.pageSize,
        search: search.delayedSearch,
        sorting,
    });

    const baseColumns = useIngredientReferenceColumns({ ingredientReferences });
    const mrt_columns = useGridColumns<IngredientReference>(baseColumns, gridKey);

    const value: IngredientReferenceListContextInitialValues = {
        page,
        setPage,
        sorting,
        setSorting,
        totalItems,
        ingredientReferences,
        mrt_columns,
        isLoading,
        search: search.search,
        delayedSearch: search.delayedSearch,
        setSearch: search.setSearch,
        resetSearch: search.resetSearch,
        showCreateModal,
        setShowCreateModal,
        gridKey,
    };

    return <IngredientReferenceListContext.Provider value={value}>{children}</IngredientReferenceListContext.Provider>;
};
